import { useEffect, useRef, useState } from 'react'

export const useFocusVisibleOutline = () => {
  const [outline, setOutline] = useState(false)
  const hadKeyboardEvent = useRef(false)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.metaKey || event.altKey || event.ctrlKey) {
        return
      }
      hadKeyboardEvent.current = true
    }

    const handlePointerDown = () => {
      hadKeyboardEvent.current = false
    }

    document.addEventListener('keydown', handleKeyDown, true)
    document.addEventListener('mousedown', handlePointerDown, true)
    document.addEventListener('touchstart', handlePointerDown, true)
    document.addEventListener('pointerdown', handlePointerDown, true)

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true)
      document.removeEventListener('mousedown', handlePointerDown, true)
      document.removeEventListener('touchstart', handlePointerDown, true)
      document.removeEventListener('pointerdown', handlePointerDown, true)
    }
  }, [])

  const handleFocus = () => {
    setOutline(hadKeyboardEvent.current)
  }

  const handleBlur = () => {
    setOutline(false)
  }

  return {
    outline,
    handleFocus,
    handleBlur,
  }
}
